angular.module('dental')
    .controller('ChargeInfoController', ['$scope', '$location', 'USE_MOCKS', function ($scope, $location, USE_MOCKS) {
        const ctrl = this;
        $scope.ctrl = ctrl;

        $scope.init = function () {
            $scope.data = JSON.parse($scope.data);

            if (USE_MOCKS) {
                $scope.state = $location.search().state || $scope.data.state;
                if (['true', 'false'].includes($location.search().status)) {
                    $scope.status = $location.search().status === 'true';
                } else {
                    $scope.status = $scope.data.status;
                }

                $scope.data = $scope.data[$scope.state];
            }

            if (!angular.isDefined($scope.status)) {
                $scope.status = $scope.data.status;
            }
        };

    }]);